import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import SearchBar from '../SearchBar';
import SearchCategoriesLinks from '../SearchCategoriesLinks';
import { translate } from '../../shared/helpers';
import { containerClass, headingClass, headingClassV16 } from './styles.ve.css';

const MAX_WIDTH_V16 = {
  default: '320px',
  sm: '536px',
  md: '726px',
  lg: '760px',
  xl: '944px',
} as const;

const TYPOGRAPHY_PROPS = {
  DEFAULT: {
    as: 'h2',
    color: 'black',
    maxWidth: '100%',
    marginX: '0',
    className: headingClass,
  },
  V16: {
    as: 'h1',
    color: 'black',
    maxWidth: MAX_WIDTH_V16,
    marginX: 'auto',
    className: headingClassV16,
  },
} as const;

interface SearchProps {
  isV16?: boolean;
  isBrandPage?: boolean;
}

const Search: React.FC<SearchProps> = ({ isV16 = false, isBrandPage = false }) => {
  const searchTitle = isBrandPage
    ? translate('search.title_freelancer')
    : translate(isV16 ? 'search_v16.title' : 'search.title');

  return (
    <Container
      maxWidth={{
        xl: '1008px',
        lg: '1004px',
        md: '790px',
      }}
      paddingLeft={{
        md: '0',
        sm: '8',
        default: '5',
      }}
      paddingY={{
        lg: '24',
        sm: '28',
        default: '20',
      }}
      className={containerClass}
      marginX="auto"
      marginY="0"
    >
      <Container
        paddingRight={{
          md: '0',
          default: '5',
        }}
      >
        <Typography {...TYPOGRAPHY_PROPS[isV16 ? 'V16' : 'DEFAULT']}>{searchTitle}</Typography>

        <SearchBar isV16={isV16} />
      </Container>

      <SearchCategoriesLinks isV16={isV16} isBrandPage={isBrandPage} />
    </Container>
  );
};

export default Search;
